import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as CustomPropTypes from 'lib/CustomPropTypes';
import { formatDuration } from 'lib/DateTime';
import AIMS_FLAVORS from 'lib/aimsFlavors';

import LazyLoad from 'components/LazyLoad';
import Picture from 'components/Picture';

const truncateAt = (value, limit) => {
  if (value.length > limit) {
    return `${value.substr(0, limit)}...`;
  }
  return value;
};

function ListItem({
  content,
  changeVideo,
  playing,
  active,
}) {
  const {
    headline,
  } = content.computedValues || {};

  const { nativeAd } = content.item;
  const itemPlaying = playing && active;

  const classes = classNames(
    'list-item__item',
    {
      'list-item__playing': itemPlaying,
      'list-item__active': active,
    },
  );

  const thumbnail = (
    <Picture
      responsiveFlavors={{
        s: AIMS_FLAVORS.FOCAL_760x380,
        m: AIMS_FLAVORS.FOCAL_320x160,
        l: AIMS_FLAVORS.FOCAL_200x100,
        xl: AIMS_FLAVORS.FOCAL_320x160,
      }}
      computedValues={content.computedValues}
    />
  );
  const videoPlayable = content.item.playable;

  const showExpiredOverlay = (
    <div className="list-item__expired-overlay-playlist items-center df absolute w-100 h-100 z-4 f3-m">
      <div className="founders-cond tc w-100 gray-60">{i18next.t('We apologize, this video has expired.')}</div>
    </div>
  );

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  return (
    <LazyLoad placeholder={false}>
      <div
        className={classes}
        onClick={() => videoPlayable && changeVideo(content.item)}
      >
        <div className="list-item__image" data-active-text={i18next.t('Now Playing')}>
          {!videoPlayable && showExpiredOverlay}
          {thumbnail}
        </div>
        <div
          className={classNames(
            'list-item__content',
          )}
          data-test="container"
        >
          <h3
            className={classNames(
              'list-item__title',
              {
                dn: !nativeAd,
              },
            )}
            data-test="paid-title"
          >
            {nativeAd && <span>{i18next.t('PAID CONTENT')}</span>}
          </h3>
          <h3 className="list-item__title" data-test="title">
            <span className="dn-l">{headline}</span>
            <span className="dn db-l dn-xl">{truncateAt(headline, 70)}</span>
            <span className="dn db-xl">{truncateAt(headline, 115)}</span>
          </h3>
          <div className="list-item__duration">
            <span data-test="timestamp">{nativeAd ? '' : formatDuration(content.item.duration)}</span>
          </div>
        </div>
      </div>
    </LazyLoad>
  );
  /* eslint-enable jsx-a11y/click-events-have-key-events */
  /* eslint-enable jsx-a11y/no-static-element-interactions */
}

ListItem.propTypes = {
  content: CustomPropTypes.video.isRequired,
  changeVideo: PropTypes.func.isRequired,
  playing: PropTypes.bool,
  active: PropTypes.bool,
};

ListItem.defaultProps = {
  playing: false,
  active: false,
};

export default ListItem;
